// src/pages/FrozenPage.js
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import BrandFooter from '../components/BrandFooter';

export default function FrozenPage() {
  const [params] = useSearchParams();
  const code = params.get('code') || '';
  const isTrial = code === 'TRIAL_EXPIRED';

  return (
    <div style={s.page}>
      <div style={s.pageCenter}>
        <div style={s.card}>
          <div style={s.icon}>{isTrial ? '⏰' : '❄️'}</div>
          <h1 style={s.title}>
            {isTrial ? 'Пробный период истёк' : 'Аккаунт заморожен'}
          </h1>
          <p style={s.text}>
            {isTrial
              ? 'Для продолжения работы оформите подписку. Обратитесь в поддержку.'
              : 'Приём заказов и доступ в админку временно приостановлены. Обратитесь в поддержку.'}
          </p>
          <a
            href="/login"
            style={s.btn}
            onClick={() => {
              sessionStorage.removeItem('auth_token');
              sessionStorage.removeItem('auth_user');
              localStorage.removeItem('auth_token');
              localStorage.removeItem('auth_user');
            }}
          >
            Выйти
          </a>
        </div>
      </div>
      <BrandFooter />
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#f5f5f7',
    fontFamily: '-apple-system, sans-serif',
  },
  pageCenter: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: '#fff',
    borderRadius: '20px',
    padding: '40px',
    maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  icon: { fontSize: '64px', marginBottom: '16px' },
  title: { fontSize: '22px', fontWeight: '700', marginBottom: '12px' },
  text: { fontSize: '15px', color: '#666', lineHeight: 1.5, marginBottom: '24px' },
  btn: {
    display: 'inline-block',
    padding: '12px 24px',
    borderRadius: '12px',
    background: '#000',
    color: '#fff',
    textDecoration: 'none',
    fontWeight: '600',
  },
};
